exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"main.vue?vue&type=style&index=0&id=3bfebbe8&scoped=true&lang=css&","sourceRoot":""}]);

// exports
